import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import WireMatchHeader from '../common/wire-match-header';
import Wire from '../common/wire';
import OrganisationResultsContext from './context';
import useScrollableWires from '../common/scrollable-wires-hooks';
import Tail from '../common/wires-list-tail';
import useGetWiresFromOrganisation from '../../../services/wires/from-organisation-service';

export default function PublishedBy({ organisation }) {
  const { dispatch } = React.useContext(OrganisationResultsContext);
  const {
    loading, infiniteRef, wires, rawData, expandList, total, showExpand, hasMore,
  } = useScrollableWires({
    isScrollable: false,
    initNumber: 20,
    useGetWires: () => useGetWiresFromOrganisation(organisation),
  });

  React.useEffect(() => {
    dispatch({
      type: 'setLoadingPublishedBy',
      // eslint-disable-next-line no-nested-ternary
      payload: !loading ? null : (wires.length ? 'more' : 'init'),
    });
  }, [loading, dispatch, wires.length]);

  React.useEffect(() => {
    if (_.get(rawData, 'wires.length')) {
      dispatch({ type: 'setPublishedByWires', payload: rawData.wires });
    }
  }, [rawData, dispatch]);

  return (
    <>
      {!!wires.length && (
        <article>
          <WireMatchHeader query={organisation} text="published by" n={total} />
          {wires.map((wire, index) => <Wire bordered={false} key={`published-by-wire-${wire.id}`} wire={wire} position={index + 1} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all results</button></Tail>
          )}
          {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
        </article>
      )}
    </>
  );
}

PublishedBy.propTypes = {
  organisation: PropTypes.string.isRequired,
};
